{
  "browserNotSupported": {
    "title": "Module kon niet worden geladen",
    "text": "Gebruik een actuele browser om de onderdelenbrowser te kunnen gebruiken."
  },
  "main": {
    "more": "Meer accessoires",
    "findMore": "Accessoires voor het achteraf in-/ombouwen en upgraden van uw voertuig vindt u hier in ons uitgebreide assortiment. De door u geselecteerde accessoires worden samen met het voertuigverzoek naar uw {{brand}} gestuurd.",
    "topOffers": "TOP Aanbiedingen",
    "article": "<0>{{min}} - {{max}} / </0>{{productCount}} Producten",
    "noArticleFound": "0 Producten",
    "oemHint": "Kies nu bijpassende accessoires voor uw {{brand}}!",
    "noBrand": "Kies nu passende accessoires voor uw voertuig!",
    "outOfOrder": "Helaas zijn er momenteel geen producten beschikbaar.<0/>We werken momenteel onze catalogus bij.<0/>Bezoek ons later nog eens.",
    "nextSlide": "Volgende",
    "prevSlide": "Vorige"
  },
  "cart": {
    "add": "Product toegevoegd aan voertuig",
    "fullPrice": "Prijs voertuig en accessoires",
    "priceWithoutCar": "Prijs accessoires"
  },
  "navigation": {
    "zoom": "Inzoomen",
    "toggleSearch": "Zoeken wisselen",
    "cart": "Winkelwagen",
    "cartDelete": "Verwijder artikel uit winkelwagen",
    "vehicle": "Geselecteerd voertuig",
    "maxBookmarksReached": "Maximaal 15 producten bereikt",
    "filter": {
      "toggleFilter": "Filter wisselen",
      "topProducts": "TOP Aanbiedingen",
      "reset": "Filter resetten",
      "ready": "Gereed",
      "show": "Toon resultaten"
    },
    "searching": {
      "submit": "Indienen",
      "close": "Sluiten",
      "placeholder": "Vind bijpassende accessoires ...",
      "suggestions": "Zoeksuggesties",
      "categories": "Categorieën",
      "products": "Producten",
      "productCount": "{{count}} product",
      "productCount_other": "{{count}} producten",
      "showAll": "{{count}} resultaat tonen",
      "showAll_other": "Alle {{count}} resultaten tonen",
      "expand": "Uitgebreid zoeken",
      "show": "Toon resultaten",
      "found": {
        "withCategory": "Zoekresultaten voor \"{{fuzzy}}\" in de categorie \"{{category}}\"",
        "withOutCategory": "Zoekresultaten voor \"{{fuzzy}}\" van alle categorieën"
      }
    },
    "share": "Deel",
    "back": "Terug",
    "details": "Details",
    "add": "Toevoegen",
    "remove": "Verwijder",
    "close": "Sluiten",
    "filtern": "Filter",
    "closeFilter": "Filter sluiten"
  },
  "productDetail": {
    "gallery": {
      "jumpToImageNumber": "Ga naar afbeelding {{number}}"
    },
    "articleNumber": "Artikelnummer",
    "relatedArticle": "Misschien Is dit artikel ook iets voor u:",
    "brand": "Merk",
    "priceBox": {
      "withVatAndMounting": "incl. btw & montage",
      "withVat": "incl. btw",
      "recommendedRetailPrice": "Oorspronkelijke prijs",
      "historicMinimalPurchasePrice": "Laagste prijs in de afgelopen 30 dagen",
      "priceDetails": "Prijsinformatie",
      "priceDetailsHeadline": "Details over de prijs voor dit artikel",
      "priceToday": "Prijs voor dit artikel vandaag",
      "priceDetails30Days": "Laagste prijs in de 30 dagen voorafgaand aan de prijswijziging",
      "close": "Sluiten",
      "addItem": "Artikel toevoegen",
      "removeItem": "Artikel verwijderen"
    },
    "infoBox": {
      "description": "Beschrijving",
      "vehicles": "Geschikt voor volgende modellen",
      "empty": "Er zijn geen speciale voertuigtoewijzingen voor dit product.",
      "contacts": "Fabrikant"
    },
    "contacts": {
      "manufacturer-contact": "Contactgegevens fabrikant",
      "responsible-contact": "Verantwoordelijke persoon binnen de EU",
      "trademark": "Merk"
    }
  },
  "productList": {
    "oemHint": "Originele accessoires voor je {{brand}}"
  }
}
